import requestApi from "../../api/fetchApi";
import {
    CalcBranchInterface,
    CalcDamageParamsInterface,
    CalcNodeInterface,
    ChartInterface,
    LastResultInfoInterface
} from "./schemas";


export class SCCCalcApi {
    static apiPrefix = "/api/projects";

    static async makeCalc(project_id: number): Promise<object> {
        return await requestApi.POST(`${this.apiPrefix}/${project_id}/calculations`);
    }

    static async getResultNodes(project_id: number): Promise<CalcNodeInterface[]> {
        return await requestApi.GET(`${this.apiPrefix}/${project_id}/calculations/result?df_name=nodes`)
            .then(body => body.rows);
    }
    static async getResultBranches(project_id: number): Promise<CalcBranchInterface[]> {
        return await requestApi.GET(`${this.apiPrefix}/${project_id}/calculations/result?df_name=branches`)
            .then(body => body.rows);
    }
    static async getResultDamageParams(project_id: number): Promise<CalcDamageParamsInterface[]> {
        return await requestApi.GET(`${this.apiPrefix}/${project_id}/calculations/result?df_name=damage_params`)
            .then(body => body.rows);
    }

    static async createChart(project_id: number): Promise<ChartInterface> {
        return await requestApi.POST(`${this.apiPrefix}/${project_id}/node_charts`);
    }
    static async duplicateChart(project_id: number, chart_id: number): Promise<ChartInterface> {
        return await requestApi.POST(`${this.apiPrefix}/${project_id}/node_charts/${chart_id}`);
    }
    static async updateChart(project_id: number, chart_id: number, chart: object): Promise<ChartInterface> {
        return await requestApi.PUT(`${this.apiPrefix}/${project_id}/node_charts/${chart_id}`, {
            body: chart,
        });
    }
    static async deleteChart(project_id: number, chart_id: number): Promise<void> {
        return await requestApi.DELETE(`${this.apiPrefix}/${project_id}/node_charts/${chart_id}`);
    }
    static async getCharts(project_id: number): Promise<ChartInterface[]> {
        return await requestApi.GET(`${this.apiPrefix}/${project_id}/node_charts`).then(charts => {
            return charts.sort(compareCharts);
        });
    }
    static async getLastResultInfo(project_id: number): Promise<LastResultInfoInterface | null> {
        return await requestApi.GET(`${this.apiPrefix}/${project_id}/calculations/last-result-info`);
    }
}


export function compareCharts(a: ChartInterface, b: ChartInterface) {
    if (a.sc_type != b.sc_type) return b.sc_type.toString() > a.sc_type.toString() ? -1 : 1;
    if (a.damage_location != b.damage_location) return (b.damage_location || 0) - (a.damage_location || 0);
    if (a.measure_location != b.measure_location) return (b.measure_location || 0) - (a.measure_location || 0);
    return 0;
}
